import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createAuthAccountReduceObject } from '../../../common/reducers/states/authAccount';

import authAccountSaga from './sagas/authAccountSaga';

export default [
  ...createCombineMapItem('authAccount', createAuthAccountReduceObject, [
    authAccountSaga
  ])
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/states/reducersMap.js